import { put, takeLatest } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { gemGPTActions } from './gemGPTslice';
import { DummyChatHistoryData, getRelevantChatData, randomResponse, simulateApiCall } from '../../pages/GemGPT/utils';

function* watchGetGemGPTChatHistoriesData() {
  try {
    yield put(gemGPTActions.setComponentStatus({ getGemGPTChatHistoryListDataLoading: true }));
    const response: AxiosResponse = yield simulateApiCall(DummyChatHistoryData, 2000);
    yield put(gemGPTActions.setChatHistoriesData(DummyChatHistoryData ?? response.data));
    yield put(
      gemGPTActions.setSelectedChatId(DummyChatHistoryData[0].chatHistory[0].chatId ?? response.data.selectedChatId),
    );
    yield put(gemGPTActions.setComponentStatus({ getGemGPTChatHistoryListDataLoading: false }));
  } catch (error: any) {
    yield put(gemGPTActions.setComponentStatus({ error: error.message, getGemGPTChatHistoryListDataLoading: false }));
  }
}
function* watchGetGemGPTChatData({ payload }: { payload: string }) {
  try {
    yield put(gemGPTActions.setComponentStatus({ getGemGPTChatDataLoading: true }));
    const response: AxiosResponse = yield simulateApiCall(getRelevantChatData(payload), 2000);
    yield put(gemGPTActions.setChatData(getRelevantChatData(payload) ?? response.data));
    yield put(gemGPTActions.setComponentStatus({ getGemGPTChatDataLoading: false }));
  } catch (error: any) {
    yield put(gemGPTActions.setComponentStatus({ error: error.message, getGemGPTChatDataLoading: false }));
  }
}

function* watchGetGemGPTResponse({ payload }: { payload: string }) {
  try {
    yield put(gemGPTActions.setComponentStatus({ getGemGPTResponseLoading: true }));
    yield put(gemGPTActions.setUserInput(payload));
    const response: AxiosResponse = yield simulateApiCall(randomResponse(), 2000);
    yield put(gemGPTActions.setBotResponse(response.data));
    yield put(gemGPTActions.setComponentStatus({ getGemGPTResponseLoading: false }));
  } catch (error: any) {
    yield put(gemGPTActions.setComponentStatus({ error: error.message, getGemGPTResponseLoading: false }));
  }
}

function* watchDeleteChat({ payload }: { payload: string }) {
  try {
    yield put(gemGPTActions.setComponentStatus({ deleteChatLoading: true }));
    yield put(gemGPTActions.removeChatFromList(payload));
    yield put(gemGPTActions.setComponentStatus({ deleteChatLoading: false }));
  } catch (error: any) {
    yield put(gemGPTActions.setComponentStatus({ error: error.message, deleteChatLoading: false }));
  }
}

function* watchCreateNewChat({ payload }: { payload: string }) {
  try {
    yield put(gemGPTActions.setComponentStatus({ createNewChatLoading: true }));
    yield put(gemGPTActions.addChatToList(payload));
    yield put(gemGPTActions.setComponentStatus({ createNewChatLoading: false }));
  } catch (error: any) {
    yield put(gemGPTActions.setComponentStatus({ error: error.message, createNewChatLoading: false }));
  }
}

export function* watchGemGPTSagas() {
  yield takeLatest(gemGPTActions.getGemGPTChatData, watchGetGemGPTChatData);
  yield takeLatest(gemGPTActions.getGemGPTChatHistoriesData, watchGetGemGPTChatHistoriesData);
  yield takeLatest(gemGPTActions.getGemGPTResponse, watchGetGemGPTResponse);
  yield takeLatest(gemGPTActions.deleteChat, watchDeleteChat);
  yield takeLatest(gemGPTActions.createNewChat, watchCreateNewChat);
}

const gemGPTSagas = watchGemGPTSagas;
export default gemGPTSagas;
